import svgs from '../svgs';

const verticalCarousel = () => {
  import('slick-carousel').then(() => {
    const $status = $('.slider-indicator');

    const $carousel = $('.js-content-vertical-carousel');
    $status.find('.indicator').on('click', (e) => {
      e.preventDefault();
      $carousel.slick('slickGoTo', $(e.target).data('key'));
    });
    $carousel.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      if (nextSlide < currentSlide) {
        $status.find(`#indicator_${currentSlide}`).removeClass('active');
      }
    });
    $carousel.on('init reInit afterChange', (event, slick, currentSlide) =>  {
      const i = (currentSlide || 0);
      $status.find(`#indicator_${i}`).removeClass('active');
      $status.find(`#indicator_${i}`).addClass('active');
    });

    $carousel.slick({
      arrows: false,
      vertical: true,
      verticalSwiping: true,
      adaptiveHeight: false,
      infinite: false,
      autoplaySpeed: 10000,
      autoplay: true,
      dots: false,
      slidesToShow: 1,
    });
  });
}

const testimonialsCarousel = () => {
  import('slick-carousel').then(() => {
    $('.js-testimonials-carousel').slick({
      arrows: false,
      dots: true,
      slidesToShow: 1,
      initialSlide: 1,
      mobileFirst: false,
      centerMode: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            centerMode: false,
          },
        },
      ]
    });
  });
}

const servicesCarousel = () => {
  $(window).on('load resize orientationchange', () => {
    const $carousel = $('.js-services-slider');
    if (!$carousel.hasClass('slick-initialized')) {
      import('slick-carousel').then(() => {
        $('.js-services-slider').slick({
          arrows: false,
          dots: true,
          slidesToShow: 1,
          mobileFirst: true,
          centerMode: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: 'unslick'
            }
          ]
        });
      });
    }
  });
}

const partnersCarousel = () => {
  $(window).on('load resize orientationchange', () => {
    const $carousel = $('.js-partners-slider');
    if (!$carousel.hasClass('slick-initialized')) {
      import('slick-carousel').then(() => {
        $('.js-partners-slider').slick({
          arrows: false,
          dots: false,
          slidesToShow: 3,
          mobileFirst: true,
          centerMode: false,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 576,
              slidesToShow: 4,
            },
            {
              breakpoint: 991,
              settings: 'unslick'
            }
          ]
        });
      });
    }
  });
}

const offersCarousel = () => {
  import('slick-carousel').then(() => {
    $('.js-offers-carousel').slick({
      arrows: true,
      dots: false,
      slidesToShow: 3,
      infinite: false,
      prevArrow: `<button type="button" class="slick-prev"><span class="svg-container">${svgs('chevronLeft')}</span></button>`,
      nextArrow: `<button type="button" class="slick-next"><span class="svg-container">${svgs('chevronRight')}</span></button>`,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });
  });
}

const homeCarousel = () => {
  import('slick-carousel').then(() => {
    $('.js-home-slider').slick({
      arrows: true,
      dots: false,
      slidesToShow: 1,
      autoplay: $('.js-home-slider').data('autoplay'),
      autoplaySpeed: parseInt($('.js-home-slider').data('duration')) * 1000,
      infinite: false,
      prevArrow: `<button type="button" class="slick-prev"><span class="svg-container">${svgs('chevronLeftSmall')}</span></button>`,
      nextArrow: `<button type="button" class="slick-next"><span class="svg-container">${svgs('chevronRightSmall')}</span></button>`,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: false,
            dots: true,
          }
        },
      ],
    });
  });
}

export { verticalCarousel, offersCarousel, testimonialsCarousel, servicesCarousel, homeCarousel, partnersCarousel } ;
